module.exports = __webpack_public_path__ + "img/120h100_gluhoe.42e501c5.svg";